module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    staticClass: "sidebar",
    attrs: {
      "span": 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add Gallery'
      }
    }
  }, [_c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('add')) + " Galerię "), _c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('ListFilterComponent', {
    attrs: {
      "selectedFilters": _vm.filters.selected,
      "listFilters": _vm.filters.available
    },
    on: {
      "setFilter": _vm.setFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "box",
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.getRouteName(_vm.$route)) + "\n                ")]), _vm._v(" "), _c('search-list-form', {
    on: {
      "submit": _vm.fetchData
    },
    model: {
      value: (_vm.filters.selected.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.selected, "search", $$v)
      },
      expression: "filters.selected.search"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "nazwa (pl)",
      "prop": "name_pl"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "edycja"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm.getEditionLabel(scope.row.edition)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "podgląd",
      "width": "340"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.images.slice(0, 3)), function(image) {
          return _c('img', {
            staticClass: "thumbnail",
            attrs: {
              "src": image.thumbnail,
              "alt": image.alt_pl
            }
          })
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'Edit Gallery',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "title": _vm.$t('edit')
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "list__pagination",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54270cdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Gallery/Galleries/GalleriesList.vue
// module id = 755
// module chunks = 0